import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toggleSearchVisible, setSearchValue } from "../../../Redux/slices/search";

const mapStateToProps = state => {
    return {
        visible: state.search.visible
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggleSearchVisible: payload => dispatch(toggleSearchVisible(payload)),
        setSearchValue: payload => dispatch(setSearchValue(payload))
    }
}

class Search extends React.Component {
    constructor() {
        super();
        this.state = {
            value: ""
        }
        this.submitSearch = this.submitSearch.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.inputRef = React.createRef();
    }

    onChange(e) {
        this.setState({
            value: e.target.value
        });
    }

    submitSearch(e) {
        if (e) { e.preventDefault(); };
        this.props.history.push("/search/?q=" + this.state.value);
        this.props.toggleSearchVisible(false);
        this.props.setSearchValue(this.state.value);
        this.setState({
            value: ""
        });
        this.inputRef.current.blur();
    }

    onFocus(action) {
        if (this.props.onFocus) {
            this.props.onFocus(action);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            this.inputRef.current.focus();
        }
    }

    render() {
        return <form className="search-form" onSubmit={this.submitSearch}>
            <input type="text"
                className="search-input"
                placeholder="Search for products..."
                value={this.state.value}
                onChange={this.onChange}
                onFocus={() => this.onFocus("in")}
                onBlur={() => this.onFocus("out")}
                ref={this.inputRef} />
            <div className="submit-btn" onClick={this.submitSearch}>Search</div>
        </form>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Search));